<script>
import TabNav from './tab-nav'

export default {
  name: 'sTabs',
  data() {
    return {
      currentName: '' + (this.value || this.activeName),
      panes: []
    }
  },
  components: {
    TabNav
  },
  props: {
    activeName: String,
    closable: Boolean,
    addable: Boolean,
    value: {},
    editable: Boolean,
    beforeLeave: Function,
    stretch: Boolean
  },
  provide() {
    return {
      rootTabs: this
    }
  },
  watch: {
    activeName(value) {
      this.setCurrentName(value)
    },
    value(value) {
      this.setCurrentName(value)
    },
    currentName() {
      if (this.$refs.nav) {
        this.$nextTick(() => {
          this.$refs.nav.$nextTick(() => {
            this.$refs.nav.scrollToActiveTab()
          })
        })
      }
    }
  },
  methods: {
    calcPaneInstances(isForceUpdate = false) {
      if (this.$slots.default) {
        const paneSlots = this.$slots.default.filter(vnode => vnode.tag &&
            vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'sTabPanel')
        const panes = paneSlots.map(({ componentInstance }) => componentInstance)
        const panesChanged = !(panes.length === this.panes.length && panes.every((pane, index) => pane === this.panes[index]))
        if (isForceUpdate || panesChanged) {
          this.panes = panes
        }
      } else if (this.panes.length !== 0) {
        this.panes = []
      }
    },
    handleTabClick(tab, tabName, event) {
      if (tab.disabled) { return }
      this.setCurrentName(tabName)
      this.$emit('tab-click', tab, event)
    },
    handleTabRemove(pane, ev) {
      if (pane.disabled) { return }
      ev.stopPropagation()
      this.$emit('edit', pane.name, 'remove')
      this.$emit('tab-remove', pane.name)
    },
    handleTabAdd() {
      this.$emit('edit', null, 'add')
      this.$emit('tab-add')
    },
    setCurrentName(value) {
      const changeCurrentName = () => {
        this.currentName = '' + value
        this.$emit('input', value)
      }
      if (this.currentName !== value && this.beforeLeave) {
        const before = this.beforeLeave(value, this.currentName)
        if (before && before.then) {
          before
            .then(() => {
              changeCurrentName()
              this.$refs.nav && this.$refs.nav.removeFocus()
            }, () => {
            })
        } else if (before !== false) {
          changeCurrentName()
        }
      } else {
        changeCurrentName()
      }
    }
  },
  render() {
    let {
      handleTabClick,
      handleTabRemove,
      handleTabAdd,
      currentName,
      panes,
      editable,
      addable,
      stretch
    } = this

    const newButton = editable || addable
      ? (
        <span
          class="s-tabs__new-tab"
          on-click={ handleTabAdd }
          tabindex="0"
          on-keydown={ (ev) => { if (ev.keyCode === 13) { handleTabAdd() } } }
        >
          <i class="s-icon-plus"></i>
        </span>
      )
      : null

    const navData = {
      props: {
        currentName,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        editable,
        panes,
        stretch
      },
      ref: 'nav'
    }
    const header = (
      <div class={['s-tabs__header', 'is-top']}>
        {newButton}
        <tab-nav { ...navData }></tab-nav>
        {this.$slots.actions}
      </div>
    )
    const panels = (
      <div class="s-tabs__content">
        {this.$slots.default}
      </div>
    )

    return (
      <div class={{
        's-tabs': true,
        ['s-tabs--top']: true,
      }}>
        { [header, panels] }
      </div>
    )
  },
  created() {
    if (!this.currentName) {
      this.setCurrentName('0')
    }

    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true))
  },
  mounted() {
    this.calcPaneInstances()
  },
  updated() {
    this.calcPaneInstances()
  }
}
</script>